import { Asset } from "assets.gen";

const imageCache = new Map<string, HTMLImageElement>();
const imageLoaded = new Map<string, boolean>();

const GFX_ASSETS: readonly string[] = [
  Asset.gfx_bg_forest0,
  Asset.gfx_bg_forest1,
  Asset.gfx_bg_forest2,
  Asset.gfx_bird,
  Asset.gfx_coin,
  Asset.gfx_copter,
  Asset.gfx_heart,
  Asset.gfx_outline_grass,
  Asset.gfx_outline_ground,
  Asset.gfx_outline_lava,
  Asset.gfx_outline_snow,
  Asset.gfx_outline_stone,
  Asset.gfx_tile_mountain,
  Asset.gfx_tile_sand,
  Asset.gfx_tile_snow,
  Asset.gfx_tile_stone,
  Asset.gfx_tile_swamp,
  Asset.gfx_turret_gun,
  Asset.gfx_turret_tower,
];

export function getImage(src: string): HTMLImageElement | null {
  return imageCache.get(src) ?? null;
}

export function isImageReady(src: string): boolean {
  return imageLoaded.get(src) === true;
}

function loadImage(src: string): Promise<void> {
  return new Promise((resolve, _reject) => {
    const img = new Image();
    img.src = src;
    imageCache.set(src, img);
    img.onload = () => {
      imageLoaded.set(src, true);
      resolve();
    };
    img.onerror = () => {
      console.error(`Failed to load image: ${src}`);
      resolve();
    };
  });
}

export function loadImages(): Promise<void>[] {
  return GFX_ASSETS.map(loadImage);
}
